import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import PersonalInformationModelPopup from "components/modelpopup/PersonalInformationModelPopup";

const ViewResignationAttachment = ({fields, remove, disabled}) => {

//     const [attachmentData, setAttachmentData] = useState([]) 

//   useEffect(()=>{
//  console.log(userData)
//         const attachments = userData?.attachments
//         setAttachmentData(attachments) 
//   },[userData])  

  const handleDownloadAll = (data) => {
    
   
        if (!data || data.length === 0) {
            alert("No attachments available to download.");
            return;
          }
        
         
        
            // Create a temporary anchor element for downloading
            const link = document.createElement('a');
            link.href = data.url;
            link.target = "_blank";
        
            // Set file name or fallback to URL file name
            link.download = data.name || data.url.split('/').pop();
        
            // Trigger download
            document.body.appendChild(link);
            link.click();
        
            // Clean up the DOM
            document.body.removeChild(link);
         
 

  };


  return (
    <>
      <div className="tab-content">
        <div id="emp_profile" className="pro-overview tab-pane fade show active">            
          <div className="mail-attachments">
            <p>
                <i className="fa-solid fa-paperclip" /> {fields?.length} Attachments {" "}
          
                {fields?.length > 0 ? (
                    <>
                        <Link to="#">View all</Link> 
                       
                    </>
                    ) : (
                    <div></div>
                    )}
            </p>
            <ul className="attachments clearfix">
            {fields?.length > 0 ? (
                    <>
                        {fields?.map((item, index) => (
                <ListItem
                id={item.id}
                key={index}
                item={item}
                download={handleDownloadAll}
                remove={remove}
                index={index}
                disabled={disabled}
                />
            ))}
                    </>
                    ) : (
                    <div></div>
                    )}

              

                
            </ul>
          </div>              
        </div>  

   
      </div>
      {/* Model Popup*/}
      <PersonalInformationModelPopup />
    </>
  );
};

export const ListItem = ({ item, key, remove, index, disabled }) => {
    console.log(index, "LLL")
    return(
    <li>
        <div className="attach-file">
            {
                item?.url.split(".").pop() == "pdf" ?
                <i className="fa-solid fa-file-pdf"></i>
            :
            <img style={{ height: '130px'}} src={item.url} alt="" />
            }
            
        </div>
        <div className="attach-info align-right d-flex justify-content-end ">
            {" "}
            <Link className="attach-filename me-2" onClick={() => window.open(item.url, '_blank')} >
                <i className="attach-fileize fa-solid fa-eye"/>
            </Link>{" "}
            {
              !disabled &&
              <Link className="attach-filename" onClick={() => remove(index)} >
              <i className="attach-fileize fa-solid fa-trash"/>
          </Link>
            }
           {" "}      
        </div>
    </li>
    )
};

export default ViewResignationAttachment;
